import { Button, Classes, InputGroup, Intent } from "@blueprintjs/core";
import classNames from "classnames";
import { NiraDialog } from "components/common/NiraDialog";
import { useState } from "react";
import { scenarioCount } from "../ScenarioRerun/bulkRerunToast";
import { BulkScenarioDraft } from "./bulkScenarioDrafts";
import css from "./BulkScenarioFormatTitlesDialog.module.scss";
import { BulkScenarioUploadLabel } from "./bulkScenarioUploadLabels";
import { TextScenarioTitleFormat } from "./scenarioTitleFormat";

/** Ask for the text `format` adds to the drafts' titles, previewing it on the first one. */
export const BulkScenarioFormatTitlesDialog: React.FC<{
    readonly format: TextScenarioTitleFormat;
    readonly drafts: ReadonlyArray<BulkScenarioDraft>;
    readonly onClose: () => void;
    readonly onApply: (text: string) => void;
}> = ({ format, drafts, onClose, onApply }) => {
    const [text, setText] = useState("");
    const [previewDraft] = drafts;
    const isBlank = text.trim() === "";
    const apply = () => {
        if (!isBlank) {
            onApply(text);
        }
    };

    return (
        <NiraDialog
            isOpen
            onClose={onClose}
            eyebrow={BulkScenarioUploadLabel.FormatTitles}
            title={format.label}
            gap="small"
            footerActions={
                <>
                    <Button text="Cancel" onClick={onClose} size="large" />
                    <Button
                        text={`Apply to ${scenarioCount(drafts.length)}`}
                        intent={Intent.PRIMARY}
                        disabled={isBlank}
                        onClick={apply}
                        size="large"
                    />
                </>
            }
        >
            <form
                onSubmit={(event) => {
                    event.preventDefault();
                    apply();
                }}
            >
                <InputGroup
                    autoFocus
                    aria-label={format.label}
                    value={text}
                    onValueChange={setText}
                />
            </form>
            {previewDraft !== undefined && (
                <span
                    className={classNames(
                        Classes.TEXT_MUTED,
                        css["BulkScenarioFormatTitlesDialog-preview"]
                    )}
                >
                    Preview:{" "}
                    {isBlank
                        ? previewDraft.title
                        : format.apply(previewDraft.title, text)}
                </span>
            )}
        </NiraDialog>
    );
};
